module.exports = __webpack_public_path__ + "2e3e652daba3badcd7edb1d1d50d4499.png";